import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import { MedKitNumberField, MedKitSelect } from '@bigpicturemedical/medkit';
import { DvCodedText, DvProportion, DvQuantity } from '@bigpicturemedical/openehr-vue';
import { BlockContainer, BlockHeader, BlockPanel } from './_layout';
export default /*#__PURE__*/ _defineComponent({
    __name: 'PulseOximetryBlock',
    props: {
        path: null,
        name: null,
        description: null,
        errors: null
    },
    setup(__props) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(BlockContainer), { class: "space-y-6" }, {
                default: _withCtx(() => [
                    _createVNode(_unref(BlockHeader), null, {
                        heading: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.name), 1)
                        ]),
                        description: _withCtx(() => [
                            _createTextVNode(_toDisplayString(props.description), 1)
                        ]),
                        _: 1
                    }),
                    _createVNode(_unref(BlockPanel), { class: "p-6 grid grid-cols-3 gap-4" }, {
                        default: _withCtx(() => [
                            _createVNode(_unref(DvProportion), {
                                path: props.path.add('spo')
                            }, {
                                default: _withCtx(({ name, description, numeratorMin, numeratorMax, numerator, setNumerator, validate, validateIfAlreadyValidated, errors, required }) => [
                                    _createVNode(_unref(MedKitNumberField), {
                                        percentage: "",
                                        "model-value": numerator,
                                        label: name,
                                        "help-text": description,
                                        error: errors[0],
                                        min: numeratorMin,
                                        max: numeratorMax,
                                        required: required,
                                        "onUpdate:modelValue": setNumerator,
                                        onInput: validateIfAlreadyValidated,
                                        onBlur: validate
                                    }, null, 8, ["model-value", "label", "help-text", "error", "min", "max", "required", "onUpdate:modelValue", "onInput", "onBlur"])
                                ]),
                                _: 1
                            }, 8, ["path"]),
                            _createVNode(_unref(DvCodedText), {
                                path: props.path.add('inspired_oxygen.method_of_oxygen_delivery')
                            }, {
                                default: _withCtx(({ name, description, options, selected, setSelected, validate, errors, required }) => [
                                    _createVNode(_unref(MedKitSelect), {
                                        "model-value": selected,
                                        label: name,
                                        "help-text": description,
                                        options: options,
                                        error: errors[0],
                                        required: required,
                                        "onUpdate:modelValue": setSelected,
                                        onInput: validate
                                    }, null, 8, ["model-value", "label", "help-text", "options", "error", "required", "onUpdate:modelValue", "onInput"])
                                ]),
                                _: 1
                            }, 8, ["path"]),
                            _createVNode(_unref(DvQuantity), {
                                path: props.path.add('inspired_oxygen.flow_rate')
                            }, {
                                default: _withCtx(({ name, description, magnitude, unit, unitOptions, min, max, setMagnitude, setUnit, validate, validateIfAlreadyValidated, errors, required }) => [
                                    _createVNode(_unref(MedKitNumberField), {
                                        "model-value": magnitude,
                                        unit: unit,
                                        label: name,
                                        min: min,
                                        max: max,
                                        "help-text": description,
                                        "unit-options": unitOptions,
                                        error: errors[0],
                                        required: required,
                                        "onUpdate:modelValue": setMagnitude,
                                        "onUpdate:unit": setUnit,
                                        onInput: validateIfAlreadyValidated,
                                        onBlur: validate
                                    }, null, 8, ["model-value", "unit", "label", "min", "max", "help-text", "unit-options", "error", "required", "onUpdate:modelValue", "onUpdate:unit", "onInput", "onBlur"])
                                ]),
                                _: 1
                            }, 8, ["path"])
                        ]),
                        _: 1
                    })
                ]),
                _: 1
            }));
        };
    }
});
